import {z} from 'zod'

import {ApiError} from 'src/api/errors'

const plannedJobsRefusalSchema = z.object({
    detail: z.object({code: z.literal('planned_jobs'), planned_job_count: z.number()}),
})

/** Read `planned_job_count` from a 409 `planned_jobs` response, or null. */
export function plannedJobsToCancel(error: unknown): number | null {
    if (!(error instanceof ApiError) || error.status !== 409) {
        return null
    }

    const refusal = plannedJobsRefusalSchema.safeParse(error.body)
    return refusal.success ? refusal.data.detail.planned_job_count : null
}
